import { FluidImage as ImageType } from '@codersclan/gatsby-theme-airfleet/src/@types';
import { graphql, useStaticQuery } from 'gatsby';
import { PartnerSectionData } from '../@types/partner';

interface PartnersQueryResponse {
  allWpPartner: {
    nodes: Partner[];
  };
}

interface Partner {
  id: string;
  title: string;
  slug: string;
  partnerCategories: {
    nodes: Array<{
      slug: string;
      name: string;
    }>;
  };
  partnersType: {
    nodes: Array<{
      slug: string;
    }>;
  };
  templatePartners: {
    partnerSection: PartnerSectionData;
  };
  featuredImage: {
    node: ImageType;
  };
  content: string;
}

export default function usePartners(typeFilter: string) {
  const data: PartnersQueryResponse = useStaticQuery(graphql`
    {
      allWpPartner(sort: { fields: title, order: ASC }) {
        nodes {
          id
          title
          slug
          partnerCategories {
            nodes {
              slug
              name
            }
          }
          partnersType {
            nodes {
              slug
            }
          }
          templatePartners {
            partnerSection {
              data {
                __typename
                ... on WpPartner_Templatepartners_PartnerSection_Data_PdfFile {
                  mediaSelector {
                    localFile {
                      publicURL
                    }
                  }
                }
                ... on WpPartner_Templatepartners_PartnerSection_Data_Url {
                  label
                  target
                  url
                  pageSelector {
                    ...PageSelectorFragment
                  }
                }
              }
            }
          }
          featuredImage {
            node {
              ...FluidImageFragmentWide
            }
          }
          content
        }
      }
    }
  `);

  let partners = data.allWpPartner.nodes;

  if (typeFilter) {
    partners = partners.filter(partner =>
      partner.partnersType.nodes.reduce(
        (acc: boolean, current) => acc || current.slug === typeFilter,
        false,
      ),
    );
  }

  return partners;
}
